export enum ParcelServiceProvider {
    Gls = 'gls',
    PostNord = 'postnord',
}
